module.exports = __webpack_public_path__ + "static/SerhiiUkrainets-a9f98deb8f549e053fed4d5c903600ca.png";